"use client";

import { Container } from "@/components/ui/tailwind-components";

export type FooterProps = {
  text: string;
  variant?: "simple" | "modern" | "gradient";
};

export function FooterSection({ text, variant = "modern" }: FooterProps) {
  const backgroundClasses = {
    simple: "bg-white border-t border-gray-200",
    modern: "bg-white/80 backdrop-blur-sm border-t border-gray-200/50",
    gradient: "bg-gradient-to-r from-gray-50 via-white to-blue-50 border-t border-gray-200/50"
  };

  return (
    <footer className={`py-12 ${backgroundClasses[variant]}`}>
      <Container>
        <div className="text-center">
          <p className="text-gray-600 font-medium">
            {text}
          </p>
          {/* <p className="text-sm text-gray-500 mt-2">
            Built with ❤️ from BLinio Modern Tailwind CSS
          </p> */}
        </div>
      </Container>
    </footer>
  );
}
